<template>
  <div class="entity-details-layout entity-details-layout-list">
    <icon-in-circle class="entity-details-icon">
      <font-awesome-icon icon="box-open"/>
    </icon-in-circle>
    <div class="entity-details-header pv3 pv4-l ph3 ph1-l">
      <span class="db ttu f6 fw6 entity-secondary">Позиции</span>
    </div>
    <request :method="request.method" :params="request.params" #default="{ loading, error }" v-model="response">
      <content-spinner v-if="loading" class="ma3"/>
      <div v-else-if="error" class="ma3">Ошибка: {{ error }}</div>
      <div v-else class="entity-details-content ml4-l bt b--near-white bw1 list-grid">
        <div  v-for="(item, index) in positions" :key="index" class="list-item flex flex-column">
          <div class="f6 entity-secondary ttu lh-title tracked flex justify-between mw7">
            <div>Позиция № {{ item.sequence_no }}</div>
          </div>
          <div class="lh-copy mv3">
            {{ product(item.product_id).name }}
          </div>
          <div class="nomenclature-details">
            <div class="entity-secondary ttl tr">Рыночная</div>
            <div>1 шт.</div>
            <div>{{ product(item.product_id).market_price }} <span class="entity-secondary">руб.</span></div>

            <div class="entity-secondary ttl tr">Заказано</div>
            <div>{{ item.ordered.count }} шт.</div>
            <div>{{ item.ordered.count * product(item.product_id).market_price }} <span class="entity-secondary">руб.</span></div>

            <div class="entity-secondary ttl tr">Утверждено</div>
            <div>{{ item.approved.count }} шт.</div>
            <div>{{ item.approved.summary }} <span class="entity-secondary">руб.</span></div>
          </div>
        </div>
      </div>
    </request>
  </div>
</template>

<script>
import Request from '@/components/Request.vue'
import ContentSpinner from '@/components/ui/progress/ContentSpinner.vue'
import IconInCircle from '@/components/ui/IconInCircle.vue'

export default {
  props: ['claim'],
  components: {
    IconInCircle,
    Request,
    ContentSpinner
  },
  computed: {
    positions () {
      return this.response.claimPositions.map((pos, i) => ({
        sequence_no: i + 1,
        product_id: pos.nomenclatureId,
        ordered: { count: pos.amount, summary: pos.marketPrice },
        approved: { count: pos.confirmedAmount, summary: pos.confirmedPrice }
      }))
    },
    products () {
      return this.response.claimPositions.map((pos, i) => ({
        id: pos.nomenclatureId,
        name: pos.nomenclatureName,
        market_price: pos.marketPrice,
        unit: pos.unitName
      }))
    }
  },
  data () {
    return {
      request: {
        method: 'getClaimDetails',
        params: {
          claimId: this.claim.id
        }
      },
      response: null
    }
  },
  methods: {
    product (id) {
      return this.products.find((p) => p.id === id)
    }
  }
}
</script>

<style lang="scss" scoped>
.nomenclature-details {
  display: grid;
  grid-template-columns: auto auto 1fr;
  grid-column-gap: 16px;
}
</style>
